import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JgPhysicalInspUnitDw } from '../models/jg/jg-physical-insp-unit-dw.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';

@Injectable({
  providedIn: 'root',
})
export class JgPhysicalInspUnitDwService extends RequestService<JgPhysicalInspUnitDw> {
  static PATH = '/jg/physicalInsp/unitDw';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService,
  ) {
    super(httpClient, JgPhysicalInspUnitDwService.PATH, globalService.debugUrl);
  }
}
